<div class="flex-1 d-flex fd-col ai-stretch">
  <span class="header">{{ option.filterMethodConfig?.title || 'Between Boxes' }}</span>

  <div class="d-flex fd-row gap-8" style="flex: 0 1" [formGroup]="formGroup">
    <div class="basis-50">
      <!-- Greater Than -->
      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Minimum</mat-label>
        <input
          #greaterThanInput
          type="number"
          formControlName="greaterThan"
          matInput
          placeholder="0"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
    <div class="basis-50">
      <!-- Less Than -->
      <mat-form-field class="form-field" appearance="outline">
        <mat-label>Maximum</mat-label>
        <input
          #lessThanInput
          type="number"
          formControlName="lessThan"
          matInput
          placeholder="0"
          autocomplete="off"
        />
      </mat-form-field>
    </div>
  </div>
</div>
